export default {
  header: {
    "kuaiche": "AICT",
    "ai": "AI Core",
    "clusterAgent": "Cluster Agent",
    "divine": "Six Swords",
    "tianlongbabu": "Tianlongbabu",
    "corporate": "Code of Conduct",
    "qualification": "Honors",
    "hire": "Join Us"
  },
  home: {
    slideTxt1: 'Building a chain and platform for the urban digital economy industry',
    slideTxt2: 'Empowering platform chain owners with AI digitization and intelligence',
    exhibitionHallTitle1: 'City Exhibition Hall + Digital Economy Platform',
    exhibitionHallTitle2: '城市客厅+数字经济平台',
    topBrandTitle1: 'The Top 100 Enterprises in Zhongshan City', 
    topBrandTitle2: '中山城市100强链主', 
    numbers: {
      cityLivingRoom: 'City Living Room',
      centralEnterprises: 'Cooperative "Chain Owner" Central Enterprises',
      domesticIP: 'Cooperative "Chain Owner" Domestic IP',
      internationalIP: 'Cooperative "Chain Owner" International IP',
      onlinePlatform: 'Online Platforms',
      scenicSpots: 'Cooperative "Chain Owner" Scenic Spots',
      walkingStreets: 'Cooperative "Chain Owner" Famous Walking Streets',
      hotels: 'Cooperative "Chain Owner" Hotels & Cultural Accommodations'
    }
  },
  footer: {
    address: 'Address',
    addressDetail: 'No.2 Gate, City Living Room Exhibition Hall, Boai 6th Road, Zhongshan',
    publicAccount: 'Official Account',
  },
  digitalPlatform: {
    homeTitle1: 'Digital City: Linkage, Empowerment: Chain Leader',
    homeTitle2: '数字城市：链接、赋能：链主',
  },
  aboutUs: {
    introTitle: 'Introduction to Express Technology',
    businessTitle: 'The main business of Fast Car Technology',
    cityTitle: 'Welcome visitors from all directions in the name of the city',
    cityPreTitle: 'Government/Super IP/Partner/Super Buyer, visit 300 annually+',
    msgTitle: 'Good news for KuaiExpress Technology',
    goDetails: 'View details',
    highlights: {
      item1: 'Launch of the Zhongshan Industrial Products Online Exhibition and Sales Platform',
      item2: 'Strategic cooperation agreement signed for the International City Living Room',
      item3: '"Ling Shu" has successfully passed the artificial intelligence service filing with the Cyberspace Administration of China',
      item4: 'Three self-developed AI application systems selected for the province\'s first batch of manufacturing empowerment resources',
      item5: 'Culture and tourism strategic cooperation agreement signed',
      item6: 'Pre-IPO investment letter of intent signed',
      item7: 'AICT technology achievement assessment: leading in China',
      item8: 'Global strategic cooperation agreement signed',
      item9: 'Low-altitude smart city living room cooperation agreement signed',
    },
  },
  digitalEmpowerment: {},
  // 在现有的翻译对象中添加
  cityLivingroom: {
    title: 'City Living Room',
    livingRooms: {
      zhongshan: 'Greater Bay Area Zhongshan City Living Room',
      quanzhou: 'Fujian Quanzhou City Living Room',
      nanyue: 'Hunan Nanyue City Living Room',
      haizhu: 'Guangzhou Haizhu Low-altitude Model City Living Room',
      yantian: 'Shenzhen Yantian Low-altitude City Living Room',
      lishui: 'Zhejiang Lishui City Living Room',
      harbin: 'Harbin City Living Room',
      macau: 'Macau City Living Room',
      malaysia: 'Malaysia City Living Room',
      thailand: 'Thailand City Living Room'
    }
  },
  innovativeProduct: {
    ipTitle: 'IP Collaboration + City Cultural Creation + Industrial Cultural Creation + Independent Innovation',
    productDesc: 'Self-developed City Brain, Digital City Terminal Products',
  },
  integratedSolution: {
    title: 'Integrated Solutions',
    solutions: {
      zhongshan: 'Zhongshan Digital Economy Industry Platform + Zhongshan City Living Room Integrated Solution',
      yantian: 'World\'s Largest Port, Yantian Low-altitude City Living Room + Low-altitude Global Product Selection Export Platform',
      quanzhou: 'Quanzhou Digital Economy Industry Platform + Quanzhou City Living Room Integrated Solution',
      harbin: 'Harbin Digital Economy Industry Platform + Harbin City Living Room Integrated Solution',
      lishui: 'Lishui Digital Economy Industry Platform + Lishui City Living Room Integrated Solution'
    }
  },
  hire: {
    applyNow: 'Apply Now',
    tabs: {
      rules: 'Code of Conduct',
      positions: 'Company Structure'
    },
    allJobs: 'All Positions',
    noPositions: 'No open positions at this time',
    groups: {
      operation: 'Industrial Agent Operations Center',
      efficiency: 'Digital Organization Efficiency Center',
      business: 'Digital Market Business Development Center',
      technology: 'Industrial Agent Technology Engineering Center',
      governance: 'Governance & City Partners',
      other: 'Other Positions'
    },
    cardTags: {
      recruitment: 'Job Description',
      responsibilities: 'Responsibilities',
      content: 'Job Duties'
    },
    columns: {
      codes: 'No.',
      position: 'Position',
      under: 'Center',
      location: 'Location',
      openings: 'Openings',
      details: 'Job details'
    },
    applyDialogTitle: 'Submit Your Resume',
    applyDialogTip: 'Please send your resume to the following email:',
    applyDialogCopy: 'Copy',
    applyDialogCopied: 'Email copied',
    location: 'Location',
    companyIntro: 'AICT Introduction',
    companyIntroContent1: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;AI Express Technology, founded on August 8, 2008, was rated as one of the top 20 innovative layer three board enterprises in the growth of the Beijing Stock Exchange in 2023. Its stock code is 872498. <strong>Currently, it is a national level specialized, refined, and new "little giant" enterprise </strong> and also an AI platform enterprise of the State Council\'s "Chain Action". Having been deeply involved in the digitalization of urban level industries for 17 years, we have become a global leader in AI applications, <strong>using AI to enhance the increment of chain owners and cities, and build a digital industrial chain.</strong>',
    companyIntroContent2: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Chain owner enterprise customers are very concerned about how to increase sales and buyer favorability. AI Express Technology uses technologies such as digital humans, metaverse, AI sales matrix, AI customer service, digital assets, etc. to achieve sales growth, increase performance, and increase buyer trust for the enterprise!',
    companyIntroContent3: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In the dual cycle model of "urban living room+urban industry digital platform", we are the pioneer of innovative models, the setter of industry standards, and the leader of AI application industries. Currently, this model has been highly recognized by managers in multiple cities both domestically and internationally, and we have reached cooperation intentions. Our corporate vision is to empower 100+cities, 1000+industries, and 10000+chain leading enterprises with AI, enabling more cities and industries to have AI online, and enabling Chinese technological strength to contribute to the world!',
    title: 'Open positions',
    readBeforeApply: 'Must Read Before Applying',
    newsItems: {
      news1: 'Digital City Living Room Globalization Strategy [National Little Giant: AI Express Technology]',
      news2: "FastTech Launches Nasdaq IPO Plan to Empower Global Digital Economy with 'Urban Living Room' Model",
      news3: 'Deeply Implement the "AI Action+" Initiative: Practical Implementation in Scenic Areas',
      news4: 'AI empowering urban digital economy development is truly amazing! Blue Ocean Track: City 2 City',
      news5: 'Industrial AI Lands in Industrial Clusters: AI Express Technology Races for Hong Kong 18C Listing'
    }
  }
}